<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>

    <!-- <div class="addingItemComponentForm"> -->
    <v-form ref="form1" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <span v-if="this.kolicinaVina > 0"
            >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
            {{ this.jm_mark }}</span
          >
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="date = parseDate(dateFormatted)"
              :disabled="!edit"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label="Vreme"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
            <v-time-picker
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-autocomplete
            ref="element1"
            v-model="aditiv_gruop_select"
            :items="aditive_gruope_items"
            item-text="name"
            item-value="id"
            label="Grupa dodataka"
            v-on:change="getAllAditiv"
            :disabled="izmena_aditiva || !edit"
            required
            :rules="[(v) => !!v || 'Obavezan podatak']"
          ></v-autocomplete>
        </v-flex>

        <v-flex xs5 pa-2>
          <v-autocomplete
            ref="element2"
            v-model="aditiv_select"
            :items="aditiv_items"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Dodatak"
            required
            return-object
            v-on:change="getAllJediniceMereAditiv"
            :disabled="izmena_aditiva || !edit"
            lazy-validation
          ></v-autocomplete>
        </v-flex>
        <v-flex
          xs1
          pa-2
          style="
            padding-top: 20px !important;
            padding-left: 0px !important;
            padding-top: 20px !important;
            max-width: 40px !important;
          "
          v-if="1===2"
        >
          <v-icon
            slot="activator"
            @click="otvoriSifarnik"
            style="color: #018389; padding-left: 0px; font-weight: bold"
            title="Dodavanje repromaterijala"
            v-if="!izmena_aditiva && edit && aditiv_gruop_select !== undefined"
            >add</v-icon
          >
        </v-flex>
      </v-layout>
    </v-form>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="quantityRelative"
            label="Količina"
            type="number"
            min="0"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="!edit"
            v-on:change="getQuantity"
          ></v-text-field>
          <!-- v-on:change="getKolicina" -->
        </v-flex>
        <v-flex xs1 pa-2>
          <v-select
            v-model="select_relative"
            :items="jm_items_relative"
            :item-text="getFieldTextJM"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            v-on:change="getQuantity"
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <!-- <v-flex
          xs1
          pa-2
          style="
           padding-top: 15px !important;
            max-width: 35px !important;
            
          "
           v-if="oksigenacija"
        >
        <img
          src="../assets/menuIcons/kosa_crta.png"
        />
        </v-flex> -->
        <v-flex xs2 pa-2 v-if="oksigenacija">
          <v-autocomplete
            v-model="oksigenacija_period_select"
            :items="oksigenacija_period_items"
            item-text="name"
            item-value="id"
            label="Period"
            :disabled="izmena_aditiva || !edit"
            required
            :rules="[(v) => !!v || 'Obavezan podatak']"
            persistent-hint
            return-object
            v-on:change="preracunajRelativnuKolicinu"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs1 style="padding-left: 10px">
          <v-icon
            slot="activator"
            id="FloatingButton"
            @click="submit_parameter"
            title="Spisak izdatnica"
            >add</v-icon
          >
        </v-flex>
        <!-- <v-flex xs2 pa-2>
          <v-text-field v-model="lot" label="Lot"></v-text-field>
        </v-flex>

        <v-flex xs3 pa-2>
          <v-text-field
            v-model="manufacturer"
            label="Proizvođač"
          ></v-text-field>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-text-field v-model="supplier" label="Dobavljač"></v-text-field>
        </v-flex> -->
        <template v-if="tip_tanka !== '15' && !oksigenacija">
          <v-flex xs2 v-if="!komad">
            <v-subheader>Dodavanje u odnosu na poslednji isti </v-subheader>
          </v-flex>
          <v-flex xs3 pa-2>
            <v-checkbox
              :label="label1"
              v-model="cvalue1"
              :checked="cvalue1"
              @change="onCheckboxChange1"
              :disabled="!edit"
              v-if="!komad"
            ></v-checkbox>
          </v-flex>
          <v-flex xs3 pa-2>
            <v-checkbox
              :label="label2"
              v-model="cvalue2"
              :checked="cvalue2"
              @change="onCheckboxChange2"
              :disabled="!edit"
              v-if="!komad"
            ></v-checkbox>
          </v-flex>
        </template>
        <template v-else-if="oksigenacija">
          <v-flex xs1 pa-2>
            <v-autocomplete
              v-model="oksigenacija_tip_select"
              :items="oksigenacija_tip_items"
              item-text="name"
              item-value="id"
              label="Tip"
              :disabled="izmena_aditiva || !edit"
              required
              :rules="[(v) => !!v || 'Obavezan podatak']"
              persistent-hint
              return-object
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menuOksigenacija"
              v-model="menuOksigenacija"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              :disabled="!edit"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormattedOksigenacija"
                label="Datum završetka"
                readonly
                @blur="dateOksigenacija = parseDate(dateFormattedOksigenacija)"
                :disabled="!edit"
                clearable
              ></v-text-field>
              <v-date-picker
                v-model="dateOksigenacija"
                no-title
                @input="menuOksigenacija = false"
                :min="minDateOksigenacija"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu1Oksigenacija"
              :close-on-content-click="false"
              v-model="menu1Oksigenacija"
              :nudge-right="0"
              :return-value.sync="timeOksigenacija"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!edit"
            >
              <v-text-field
                slot="activator"
                v-model="timeOksigenacija"
                label="Vreme završetka"
                readonly
                :disabled="!edit"
                clearable
                v-on:change="preracunajRelativnuKolicinu"
              ></v-text-field>
              <v-time-picker
                v-model="timeOksigenacija"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu1Oksigenacija.save(timeOksigenacija)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1Oksigenacija = false"
                  >Cancel</v-btn
                >
              </v-time-picker>
            </v-menu>
          </v-flex>
        </template>
      </v-layout>
    </v-form>
    <v-layout row wrap v-if="tip_tanka === '15'">
      <v-flex xs12 pa-2>
        <v-autocomplete
          ref="elementsarza"
          v-model="sarza_select"
          :items="sarza_items"
          :item-text="getFieldText"
          item-value="tank.id"
          label="Barik"
          multiple
          chips
          deletable-chips
          hide-no-data
          clearable
          :disabled="!edit"
        ></v-autocomplete>
        <!--  -->
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 pa-2>
        <!-- <v-textarea v-model="opis" name="input-5-1" class="Description" label="Opis"></v-textarea> -->
        <v-text-field
          v-model="opis"
          class="Description"
          label="Opis"
          ref="element3"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <!-- /.Opis -->

    <v-layout row wrap>
      <v-flex xs12>
        <v-btn
          :disabled="!valid"
          @click="submit"
          class="AppButtonFilled"
          >Sačuvaj</v-btn
        >

        <v-btn
          @click="clear_init"
          class="AppButtonOutlined"
          >odustani</v-btn
        >
      </v-flex>
    </v-layout>
    <!-- /.Action buttons -->

    <v-dialog v-model="dialogNote" scrollable content-class="ModalInModal">
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div class="box" v-if="this.select_relative !== undefined">
                Izdatnice za izbor - {{ this.selectedArticleName }}
                {{ parseFloat(this.additiveQuantity).toFixed(this.brojDec) }}
                {{ this.jm === "psc" ? "kom" : this.jm }}
              </div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <MyComponent
              @newdata="handleData($event)"
              :articleId="selectedArticlePom"
              :documentId="materialOperationIdPom"
              operation="ADDING"
              :unitOfMeasureId="select_relativePom"
              :additiveQuantity="additiveQuantityPom_za_izdatnice"
              :ID="ID"
              :izabrani_aditiv="izabrani_aditiviPom"
              :edit="edit"
            ></MyComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <AdditiveComponent
              @close="handleDataCloseOperacije($event)"
              :operationType="operacija"
            ></AdditiveComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON, isNumeric } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import MyComponent from "./AddingNewComponent";

import AdditiveComponent from "../views/AdditiveItemComponentPom.vue";

export default {
  name: "AddingItem",
  components: {
    TokenComponent,
    MyComponent,

    AdditiveComponent,
    Loading
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    selectedArticle: 0,
    selectedArticlePom: 0,
    selectedArticleName: "",
    materialOperationId: 0,
    materialOperationIdPom: 0,
    dialogNote: false,
    materialFromWarehouseDocumentItemList: [],
    label1: "Dodatak: ",
    label2: "Grupa dodataka: ",
    valid: true,
    ID: "0",
    opis: "",
    jm_items: [],
    jm_items_relative: [],
    select_relative: undefined,
    select_relativePom: "",
    aditiv_items: [],
    aditive_gruope_items: [],
    select: "",
    aditiv_select: "",
    aditiv_select_init: "",
    aditiv_gruop_select: undefined,
    menu: "",
    menuOksigenacija: "",
    dateOksigenacija: null,
    dateOksigenacijaText: null,
    dateFormattedOksigenacija: null,
    tankPhaseWineId: 0,
    time: "",
    menu1: "",
    timeOksigenacija: undefined,
    menu1Oksigenacija: "",

    oksigenacija_tip_select: undefined,
    oksigenacija_tip_items: [
      {
        id: 1,
        name: "Mikro",
      },
      {
        id: 2,
        name: "Makro",
      },
    ],
    oksigenacija_period_select: undefined,
    oksigenacija_period_items: [
      {
        id: 12,
        name: "Sat",
      },
      {
        id: 24,
        name: "Dan",
      },
      {
        id: 31,
        name: "Mesec",
      },
    ],
    // lot: "",
    // manufacturer: "",
    // supplier: "",
    quantityRelativeUnitOfMeasure: 0,
    quantityRelative: undefined,
    kolicinaVina: 0,
    kolicinaVinaInit: 0,
    faza_mark: "",
    jm_mark: "",
    quantityRelativeUnitOfMeasure_mark: "",
    cvalue1: undefined,
    cvalue2: undefined,
    sarza_items: [],
    tip_tanka: "0",
    sarza_select: [],
    izabrani_barici: [],
    date: null,
    dateFormatted: null,
    edit: true,
    additiveQuantity: 0,
    additiveQuantityPom: 0,
    additiveQuantityPom_za_izdatnice: 0,
    jm: "",
    brojDec: 1,
    izmena_aditiva: false,
    izabrani_aditivi: [],
    izabrani_aditiviPom: [],
    komad: false,
    operacija: undefined,
    dialogNote_operacije: false,
    oksigenacija: false,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    dateOksigenacija(val) {
      this.dateFormattedOksigenacija = this.formatDate1(this.dateOksigenacija);
      this.preracunajRelativnuKolicinu();
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      return this.formatDate(today);
    },
    minDateOksigenacija() {
      const pocetak = new Date(this.date);
      return this.formatDate(pocetak);
    },
  },
  methods: {
    handleDataCloseOperacije: function (e) {
      // this.getAllOperations(e.name);
      if (this.aditiv_gruop_select.id !== undefined)
        this.getAllAditiv(this.aditiv_gruop_select.id, e.name);
      else this.getAllAditiv(this.aditiv_gruop_select, e.name);

      this.dialogNote_operacije = false;
    },
    otvoriSifarnik(event) {
      if (this.aditiv_gruop_select.id !== undefined)
        this.operacija = "Dodavanje|" + this.aditiv_gruop_select.id;
      else this.operacija = "Dodavanje|" + this.aditiv_gruop_select;

      this.dialogNote_operacije = true;
    },
    handleData: function (e) {
      this.materialFromWarehouseDocumentItemList = e;
      this.dialogNote = false;

      if (this.ID !== 0) this.clear_init();

      serverBus.$emit("refresh_adding", this.tip_tanka);
    },
    getFieldTextJM(item) {
      let tekst = item.mark;

      if (item.mark === "psc") tekst = "kom";

      return tekst;
    },
    obrisiDatum() {
      this.dateOksigenacija = undefined;
      this.preracunajRelativnuKolicinu();
    },
    preracunajRelativnuKolicinu() {
      if (this.oksigenacija) {
        if (this.oksigenacija_period_select !== undefined) {
          if (this.oksigenacija_period_select.id === 12)
            this.additiveQuantity =
              this.quantityRelative *
              this.additiveQuantityPom *
              this.preracunajSate();
          else if (this.oksigenacija_period_select.id === 24)
            this.additiveQuantity =
              this.quantityRelative *
              this.additiveQuantityPom *
              this.preracunajDane();
          else if (this.oksigenacija_period_select.id === 31)
            this.additiveQuantity =
              this.quantityRelative *
              this.additiveQuantityPom *
              this.preracunajMesece();
        }
      } else
        this.additiveQuantity =
          this.quantityRelative * this.additiveQuantityPom;
    },
    preracunajSate() {
      const date1 = new Date(this.date + "T" + this.time + ":00");
      let diffTime;

      if (
        this.dateOksigenacija !== null &&
        this.dateOksigenacija !== undefined
      ) {
        const date2 = new Date(
          this.dateOksigenacija +
            (this.timeOksigenacija !== null &&
            this.timeOksigenacija !== undefined
              ? "T" + this.timeOksigenacija + ":00"
              : "")
        );

        diffTime = Math.abs(date2 - date1);
      } else diffTime = 0;

      const diffHours = Math.round((100 * diffTime) / (1000 * 60 * 60)) / 100;

      return diffHours;
    },
    preracunajDane() {
      const date1 = new Date(this.date + "T" + this.time + ":00");
      let diffTime;

      if (
        this.dateOksigenacija !== null &&
        this.dateOksigenacija !== undefined
      ) {
        const date2 = new Date(
          this.dateOksigenacija +
            (this.timeOksigenacija !== null &&
            this.timeOksigenacija !== undefined
              ? "T" + this.timeOksigenacija + ":00"
              : "")
        );

        diffTime = Math.abs(date2 - date1);
      } else diffTime = 0;
      const diffDays =
        Math.round((100 * diffTime) / (1000 * 60 * 60 * 24)) / 100;

      return diffDays;
    },
    preracunajMesece() {
      const date1 = new Date(this.date + "T" + this.time + ":00");
      let diffTime;

      if (
        this.dateOksigenacija !== null &&
        this.dateOksigenacija !== undefined
      ) {
        const date2 = new Date(
          this.dateOksigenacija +
            (this.timeOksigenacija !== null &&
            this.timeOksigenacija !== undefined
              ? "T" + this.timeOksigenacija + ":00"
              : "")
        );

        diffTime = Math.abs(date2 - date1);
      } else diffTime = 0;

      const diffMonths =
        Math.round((100 * diffTime) / (1000 * 60 * 60 * 24 * 30)) / 100;

      return diffMonths;
    },
    proveriPoljaZaOksigenaciju() {
      let nijeOK = false;

      if (this.oksigenacija) {
        if (this.$refs.form.validate())
          if (
            this.dateOksigenacija === undefined ||
            this.dateOksigenacija === null
          )
            nijeOK = true;
          else nijeOK = false;
        else nijeOK = false;
      }

      return nijeOK;
    },
    submit_parameter(e) {
      if (this.$refs.form.validate()) {
        if (
          this.aditiv_gruop_select === undefined ||
          this.aditiv_gruop_select === ""
        )
          alert("Grupa repromaterijala mora biti unešena.");
        else if (this.aditiv_select === undefined || this.aditiv_select === "")
          alert("Repromaterijal mora biti unešen.");
        else if (this.proveriPoljaZaOksigenaciju())
          alert("Unos datuma završetka oksigenacije je obavezna.");
        else if (
          this.quantityRelative > 0 &&
          this.select_relative !== undefined
        ) {
          e.preventDefault();

          if (this.oksigenacija) {
            if (this.oksigenacija_period_select !== undefined) {
              if (this.oksigenacija_period_select.id === 12)
                this.additiveQuantity =
                  this.quantityRelative *
                  this.additiveQuantityPom *
                  this.preracunajSate();
              else if (this.oksigenacija_period_select.id === 24)
                this.additiveQuantity =
                  this.quantityRelative *
                  this.additiveQuantityPom *
                  this.preracunajDane();
              else if (this.oksigenacija_period_select.id === 31)
                this.additiveQuantity =
                  this.quantityRelative *
                  this.additiveQuantityPom *
                  this.preracunajMesece();
            }
          } else
            this.additiveQuantity =
              this.quantityRelative * this.additiveQuantityPom;

          if (this.select_relative.mark !== undefined) {
            this.jm = this.select_relative.mark.split("/")[0];

            if (this.jm === "g" || this.jm === "ml" || this.jm === "psc")
              this.brojDec = 1;
            else this.brojDec = 3;
          }

          this.additiveQuantityPom_za_izdatnice = this.additiveQuantity.toFixed(
            this.brojDec
          );
          this.select_relativePom = this.select_relative;
          this.materialOperationIdPom = this.materialOperationId;
          this.selectedArticlePom = this.selectedArticle;
          this.izabrani_aditiviPom = this.izabrani_aditivi;

          this.dialogNote = true;
        } else alert("Količina i jedinica mere moraju biti unete.");
      }
    },
    popuni_izabrane_aditive(niz) {
      this.izabrani_aditivi = [];
      let index;
      let _this = this;

      if (niz !== undefined)
        niz.forEach(function (element) {
          if (element.materialFromWarehouseDocumentItemList !== undefined) {
            if (element.materialFromWarehouseDocumentItemList.length > 0)
              index = _this.izabrani_aditivi.findIndex(
                (x) =>
                  x.additiv.id === element.additiv.id &&
                  x.materialFromWarehouseDocumentItemList[0]
                    .materialOperationId ===
                    element.materialFromWarehouseDocumentItemList[0]
                      .materialOperationId &&
                  x.materialFromWarehouseDocumentItemList[0]
                    .warehouseInputOutputItem.id ===
                    element.materialFromWarehouseDocumentItemList[0]
                      .warehouseInputOutputItem.id
              );
          } else if (element.materialFromWarehouseDocumentItems.length > 0) {
            index = _this.izabrani_aditivi.findIndex(
              (x) =>
                x.additiv.id === element.additiv.id &&
                x.materialFromWarehouseDocumentItems[0].materialOperationId ===
                  element.materialFromWarehouseDocumentItems[0]
                    .materialOperationId &&
                x.materialFromWarehouseDocumentItems[0].warehouseInputOutputItem
                  .id ===
                  element.materialFromWarehouseDocumentItems[0]
                    .warehouseInputOutputItem.id
            );
          }

          if (index !== -1) _this.izabrani_aditivi.splice(index, index + 1);
          _this.izabrani_aditivi.push(element);
        });
    },
    closeModal() {
      if (this.materialFromWarehouseDocumentItemList.length === 0)
        alert("Nisu izabrane količine sa izdatnica.");

      this.izabrani_aditiviPom = [];
      this.additiveQuantityPom_za_izdatnice = undefined;
      this.select_relativePom = undefined;
      this.materialOperationIdPom = undefined;
      this.selectedArticlePom = undefined;

      this.dialogNote = false;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    onCheckboxChange1(newValue, oldValue) {
      if (newValue) {
        this.cvalue1 = true;
        this.cvalue2 = false;
      }

      this.getQuantity();
    },
    onCheckboxChange2(newValue, oldValue) {
      if (newValue) {
        this.cvalue2 = true;
        this.cvalue1 = false;
      }

      this.getQuantity();
    },
    getQuantity(e) {
      

      if (this.select_relative !== undefined) {
        if (this.select_relative.mark !== undefined) {
          if (this.select_relative.mark === "psc") this.komad = true;
          else this.komad = false;
        }

        let _this = this;
        let ostatakAditivGrupa = false;
        let ostatakAditiv = false;

        let date;
        let time;

        // const today = new Date();
        // let Minutes = `${today.getMinutes()}`;
        // let Hours = `${today.getHours()}`;

        // if (Hours.length < 2) Hours = `0${Hours}`;
        // if (Minutes.length < 2) Minutes = `0${Minutes}`;

        //time = [Hours, Minutes].join(":");

        time = this.time;

        // let Year = `${today.getFullYear()}`;
        // let Month = `${today.getMonth() + 1}`;
        // let Day = `${today.getDate()}`;

        // if (Month.length < 2) Month = `0${Month}`;
        // if (Day.length < 2) Day = `0${Day}`;

        //date = [Year, Month, Day].join("-");

        date = this.date;

        if (this.cvalue2) ostatakAditivGrupa = true;

        if (this.cvalue1) ostatakAditiv = true;

        var relativJM_id = "";

        if (typeof this.select_relative.id === "undefined")
          relativJM_id = this.select_relative;
        else relativJM_id = this.select_relative.id;

        var locSelectedArticle = "";

        if (typeof this.selectedArticle.id === "undefined")
          locSelectedArticle = this.selectedArticle;
        else {
          locSelectedArticle = this.selectedArticle.id;
          this.selectedArticleName = this.selectedArticle.name;
        }
        if (
          locSelectedArticle !== 0 &&
          locSelectedArticle !== undefined &&
          this.tankPhaseWineId !== undefined
        ) {
          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/add/quantity_on_wich_added_aditive/" +
                this.tankPhaseWineId +
                "/" +
                date +
                "T" +
                time +
                "/" +
                locSelectedArticle +
                "/" +
                relativJM_id +
                "/" +
                ostatakAditiv +
                "/" +
                ostatakAditivGrupa,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              if (!_this.komad) {
                _this.additiveQuantityPom = response.data;

                if (_this.oksigenacija) {
                  if (_this.oksigenacija_period_select !== undefined) {
                    if (_this.oksigenacija_period_select.id === 12)
                      _this.additiveQuantity =
                        _this.quantityRelative *
                        _this.additiveQuantityPom *
                        _this.preracunajSate();
                    else if (_this.oksigenacija_period_select.id === 24)
                      _this.additiveQuantity =
                        _this.quantityRelative *
                        _this.additiveQuantityPom *
                        _this.preracunajDane();
                    else if (_this.oksigenacija_period_select.id === 31)
                      _this.additiveQuantity =
                        _this.quantityRelative *
                        _this.additiveQuantityPom *
                        _this.preracunajMesece();
                  }
                } else
                  _this.additiveQuantity =
                    _this.quantityRelative * _this.additiveQuantityPom;
              } else {
                _this.additiveQuantityPom = 1;
                _this.additiveQuantity = _this.quantityRelative;
              }
            })
            .catch((e) => {
              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/add/quantity_on_wich_added_aditive/" +
                            this.tankPhaseWineId +
                            "/" +
                            date +
                            "T" +
                            time +
                            "/" +
                            locSelectedArticle +
                            "/" +
                            relativJM_id +
                            "/" +
                            ostatakAditiv +
                            "/" +
                            ostatakAditivGrupa,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          if (!_this.komad) {
                            _this.additiveQuantityPom = response.data;

                            if (_this.oksigenacija) {
                              if (
                                _this.oksigenacija_period_select !== undefined
                              ) {
                                if (_this.oksigenacija_period_select.id === 12)
                                  _this.additiveQuantity =
                                    _this.quantityRelative *
                                    _this.additiveQuantityPom *
                                    _this.preracunajSate();
                                else if (
                                  _this.oksigenacija_period_select.id === 24
                                )
                                  _this.additiveQuantity =
                                    _this.quantityRelative *
                                    _this.additiveQuantityPom *
                                    _this.preracunajDane();
                                else if (
                                  _this.oksigenacija_period_select.id === 31
                                )
                                  _this.additiveQuantity =
                                    _this.quantityRelative *
                                    _this.additiveQuantityPom *
                                    _this.preracunajMesece();
                              }
                            } else
                              _this.additiveQuantity =
                                _this.quantityRelative *
                                _this.additiveQuantityPom;
                          } else {
                            _this.additiveQuantityPom = 1;
                            _this.additiveQuantity = _this.quantityRelative;
                          }
                        })
                        .catch((e) => {
                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
      } else this.komad = false;
    },
    newSifarnik() {
      let pomocniNiz = [];

      if (this.jm === "g" || this.jm === "ml" || this.jm === "psc") {
        this.materialFromWarehouseDocumentItemList.forEach(function (entry) {
          // entry.quantity = entry.quantity / 1000;

          pomocniNiz.push(entry);
        });
      }

      var complexObjectTankPhaseWine = {
        id: this.tankPhaseWineId,
      };

      var complexObjectAdditiv = {
        id: this.aditiv_select.id !== undefined ? this.aditiv_select.id : this.aditiv_select,
      };

      let ostatakAditivGrupa = 0;
      let ostatakAditiv = 0;

      if (this.cvalue2) {
        ostatakAditivGrupa = 1;
      }

      if (this.cvalue1) ostatakAditiv = 1;

      var complexObjectSarza = [];

      let objekat;

      if (this.sarza_select !== undefined) {
        this.sarza_select.forEach(function (entry) {
          if (entry.tank !== undefined)
            objekat = {
              tank: {
                id: entry.tank.id,
              },
            };
          else
            objekat = {
              tank: {
                id: entry,
              },
            };
          complexObjectSarza.push(objekat);
        });
      }

      var complexObjectQuantityRelativeUnitOfMeasure;
      var relativJM_id = "";
      var relative_mark = "";

      if (typeof this.select_relative !== "undefined") {
        if (typeof this.select_relative.id === "undefined")
          relativJM_id = this.select_relative;
        else relativJM_id = this.select_relative.id;

        relative_mark = this.jm_items_relative.find(
          (x) => x.id === relativJM_id
        ).mark;
      }

      if (relativJM_id !== "")
        complexObjectQuantityRelativeUnitOfMeasure = {
          id: relativJM_id,
          mark: relative_mark,
        };

      var complexObject;

      if (complexObjectSarza.length === 0) {
        if (this.oksigenacija)
          complexObject = {
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantity: this.additiveQuantity,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            materialFromWarehouseDocumentItems: pomocniNiz,
            oxygenationPerodUnitOfMeasure: {
              id: this.oksigenacija_period_select.id,
            },
            oxygenationEndDate:
              this.dateOksigenacija !== undefined &&
              this.dateOksigenacija !== null
                ? this.timeOksigenacija !== undefined
                  ? this.dateOksigenacija + "T" + this.timeOksigenacija
                  : this.dateOksigenacija + "T00:00"
                : null,
            microOxygenation:
              this.oksigenacija_tip_select.id === 1 ? true : false,
            macroOxygenation:
              this.oksigenacija_tip_select.id === 2 ? true : false,
          };
        else
          complexObject = {
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            materialFromWarehouseDocumentItems: pomocniNiz,
          };
      } else {
        if (this.oksigenacija)
          complexObject = {
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantity: this.additiveQuantity,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            tankFromBatchInOperations: complexObjectSarza,
            materialFromWarehouseDocumentItems: pomocniNiz,
            oxygenationPerodUnitOfMeasure: {
              id: this.oksigenacija_period_select.id,
            },
            oxygenationEndDate:
              this.dateOksigenacija !== undefined &&
              this.dateOksigenacija !== null
                ? this.timeOksigenacija !== undefined
                  ? this.dateOksigenacija + "T" + this.timeOksigenacija
                  : this.dateOksigenacija + "T00:00"
                : null,
            microOxygenation:
              this.oksigenacija_tip_select.id === 1 ? true : false,
            macroOxygenation:
              this.oksigenacija_tip_select.id === 2 ? true : false,
          };
        else
          complexObject = {
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            tankFromBatchInOperations: complexObjectSarza,
            materialFromWarehouseDocumentItems: pomocniNiz,
          };
      }

      // console.log(JSON.stringify(complexObject));

      this.$http
        .post(
          this.globalServiceLocation + this.globalPort + "/add/create",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          serverBus.$emit("refresh_adding", this.tip_tanka);

          this.clear_init();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/add/create",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      serverBus.$emit("refresh_adding", this.tip_tanka);

                      this.clear_init();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;
              
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObjectTankPhaseWine = {
        id: this.tankPhaseWineId,
      };

      var complexObjectAdditiv = {
        id: this.aditiv_select.id !== undefined ? this.aditiv_select.id : this.aditiv_select,
      };

      let ostatakAditivGrupa = 0;
      let ostatakAditiv = 0;

      if (this.cvalue2) {
        ostatakAditivGrupa = 1;
      }

      if (this.cvalue1) ostatakAditiv = 1;

      var complexObjectSarza = [];
      let objekat;

      if (this.tip_tanka === "15") {
        let objekat;

        if (this.sarza_select !== undefined) {
          let _this = this;

          this.sarza_select.forEach(function (entry) {
            if (entry.tank !== undefined)
              objekat = {
                id: entry.id,
                tank: {
                  id: entry.tank.id,
                },
              };
            else {
              let ind = _this.izabrani_barici.findIndex(
                (x) => x.tank.id === entry
              );

              if (ind >= 0) {
                objekat = {
                  id: _this.izabrani_barici[ind].id,
                  tank: {
                    id: entry,
                  },
                };
              } else
                objekat = {
                  tank: {
                    id: entry,
                  },
                };
            }

            complexObjectSarza.push(objekat);
          });
        }
      }

      var complexObjectQuantityRelativeUnitOfMeasure;
      var relativJM_id = "";
      var relative_mark = "";

      if (typeof this.select_relative !== "undefined") {
        if (typeof this.select_relative.id === "undefined")
          relativJM_id = this.select_relative;
        else relativJM_id = this.select_relative.id;

        relative_mark = this.jm_items_relative.find(
          (x) => x.id === relativJM_id
        ).mark;
      }

      if (relativJM_id !== "")
        complexObjectQuantityRelativeUnitOfMeasure = {
          id: relativJM_id,
          mark: relative_mark,
        };

      var complexObject;

      if (complexObjectSarza.length === 0) {
        if (this.oksigenacija)
          complexObject = {
            id: this.ID,
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantity: this.additiveQuantity,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            materialFromWarehouseDocumentItems:
              this.materialFromWarehouseDocumentItemList,
            oxygenationPerodUnitOfMeasure: {
              id: this.oksigenacija_period_select.id,
            },
            oxygenationEndDate:
              this.dateOksigenacija !== undefined &&
              this.dateOksigenacija !== null
                ? this.timeOksigenacija !== undefined
                  ? this.dateOksigenacija + "T" + this.timeOksigenacija
                  : this.dateOksigenacija + "T00:00"
                : null,
            microOxygenation:
              this.oksigenacija_tip_select.id === 1 ? true : false,
            macroOxygenation:
              this.oksigenacija_tip_select.id === 2 ? true : false,
          };
        else
          complexObject = {
            id: this.ID,
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            materialFromWarehouseDocumentItems:
              this.materialFromWarehouseDocumentItemList,
          };
      } else {
        if (this.oksigenacija)
          complexObject = {
            id: this.ID,
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantity: this.additiveQuantity,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            tankFromBatchInOperations: complexObjectSarza,
            materialFromWarehouseDocumentItems:
              this.materialFromWarehouseDocumentItemList,
            oxygenationPerodUnitOfMeasure: {
              id: this.oksigenacija_period_select.id,
            },
            oxygenationEndDate:
              this.dateOksigenacija !== undefined &&
              this.dateOksigenacija !== null
                ? this.timeOksigenacija !== undefined
                  ? this.dateOksigenacija + "T" + this.timeOksigenacija
                  : this.dateOksigenacija + "T00:00"
                : null,
            microOxygenation:
              this.oksigenacija_tip_select.id === 1 ? true : false,
            macroOxygenation:
              this.oksigenacija_tip_select.id === 2 ? true : false,
          };
        else
          complexObject = {
            id: this.ID,
            tankPhaseWine: complexObjectTankPhaseWine,
            additiv: complexObjectAdditiv,
            date: this.date + "T" + this.time,
            description: this.opis,
            // lot: this.lot,
            // manufacturer: this.manufacturer,
            // supplier: this.supplier,
            quantityRelativeUnitOfMeasure:
              complexObjectQuantityRelativeUnitOfMeasure,
            quantityRelative: this.quantityRelative,
            wineQuantityAtAddingMoment: this.kolicinaVina,
            diffOnLastSameAdditive: ostatakAditiv,
            diffOnLastSameAdditiveGroup: ostatakAditivGrupa,
            tankFromBatchInOperations: complexObjectSarza,
            materialFromWarehouseDocumentItems:
              this.materialFromWarehouseDocumentItemList,
          };
      }

      // console.log(JSON.stringify(complexObject));

      this.$http
        .put(
          this.globalServiceLocation + this.globalPort + "/add/update",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          serverBus.$emit("refresh_adding", this.tip_tanka);

          this.clear_init();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/add/update",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      serverBus.$emit("refresh_adding", this.tip_tanka);

                      this.clear_init();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMereAditiv(a) {
      this.jm_items_relative = [];

      this.selectedArticle = 0;
      this.selectedArticleName = "";

      if (typeof a !== "undefined")
        if (typeof a.id !== "undefined") {
          let ind = 0;
          ind = this.aditiv_items.findIndex((x) => x.id === a.id);

          if (ind >= 0) {
            this.selectedArticle = this.aditiv_items[ind].id;
            this.selectedArticleName = this.aditiv_items[ind].name;

            this.label1 = "Dodatak: " + this.aditiv_items[ind].name;

            this.$http
              .get(
                this.globalServiceLocation +
                  this.globalPort +
                  "/additiv/" +
                  a.id +
                  "/with_unit",
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                var pomArray = [];
                this.jm_items = [];

                pomArray = response.data.unitOfMeasure;

                if (this.tankPhaseWineId !== undefined)
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/add/unit_per_ha/" +
                        this.tankPhaseWineId +
                        "/" +
                        a.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.jm_items_relative = response.data;

                      if (response.data.length === 1)
                        this.select_relative = response.data[0];

                      // if (this.additiveQuantityPom === 0)
                      //   this.getQuantity(this.select_relative);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
              })
              .catch((e) => {
                if (!e.response) {
                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        this.$http
                          .get(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/additiv/" +
                              a.id +
                              "/with_unit",
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.jm_items = [];

                            pomArray = response.data.unitOfMeasure;

                            this.$http
                              .get(
                                this.globalServiceLocation +
                                  this.globalPort +
                                  "/add/unit_per_ha/" +
                                  this.tankPhaseWineId +
                                  "/" +
                                  a.id,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization:
                                      "Bearer  " +
                                      localStorage.getItem("user-token"),
                                  },
                                }
                              )
                              .then((response) => {
                                this.jm_items_relative = response.data;

                                if (response.data.length === 1)
                                  this.select_relative = response.data[0];

                                // if (this.additiveQuantityPom === 0)
                                //   this.getQuantity(this.select_relative);
                              })
                              .catch((e) => {
                                let pomError = readJSON(
                                  e.response.data.message
                                );
                                alert(pomError);
                              });
                          })
                          .catch((e) => {
                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        }
    },
    getFieldText(item) {
      let tekst = "";

      if (item.id !== undefined) {
        if (
          item.batchPrefix !== null &&
          item.tankNumberInBatch !== null &&
          item.batchPrefix !== "" &&
          item.tankNumberInBatch !== ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name})`;
        else if (
          (item.batchPrefix === null || item.batchPrefix === "") &&
          (item.tankNumberInBatch === null || item.tankNumberInBatch === "")
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tank.name}`;
        else if (
          item.tankNumberInBatch === null ||
          item.tankNumberInBatch === ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.batchPrefix} (${item.tank.name})`;
        else if (item.batchPrefix === null || item.batchPrefix === "")
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tankNumberInBatch} | ${item.tank.name}`;
      }

      return tekst;
    },
    getAllAditiv(a, aditivZaSelektovanje) {
      //alert(a)

      this.selectedArticle = 0;
      this.selectedArticleName = "";

      if (typeof a !== "undefined")
        if (a !== "0") {
          // console.log(a);

          let ind = 0;
          ind = this.aditive_gruope_items.findIndex((x) => x.id === a);

          this.label2 =
            "Grupa dodataka: " + this.aditive_gruope_items[ind].name;

          if (this.aditive_gruope_items[ind].enumLabel === "oxygenation")
            this.oksigenacija = true;
          else this.oksigenacija = false;

          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/additiv_group/" +
                a +
                "/additives",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              this.aditiv_items = response.data;

              if (typeof this.aditiv_select !== "undefined")
                if (typeof this.aditiv_select.id !== "undefined")
                  this.getAllJediniceMereAditiv(this.aditiv_select);

              if (
                aditivZaSelektovanje !== undefined &&
                aditivZaSelektovanje !== null
              ) {
                let ind = this.aditiv_items.findIndex(
                  (x) => x.name === aditivZaSelektovanje
                );

                this.aditiv_select = this.aditiv_items[ind];
              }
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/additiv_group/" +
                            a +
                            "/additives",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          this.aditiv_items = response.data;

                          if (typeof this.aditiv_select !== "undefined")
                            if (typeof this.aditiv_select.id !== "undefined")
                              this.getAllJediniceMereAditiv(this.aditiv_select);

                          if (
                            aditivZaSelektovanje !== undefined &&
                            aditivZaSelektovanje !== null
                          ) {
                            let ind = this.aditiv_items.findIndex(
                              (x) => x.name === aditivZaSelektovanje
                            );

                            this.aditiv_select = this.aditiv_items[ind];
                          }
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        } else
          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/additiv/all_with_unit",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              this.aditiv_items = response.data;
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/additiv/all_with_unit",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          this.aditiv_items = response.data;
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
      else {
        this.oksigenacija = false;
        this.aditiv_items = [];
      }
    },
    getAllSarze(id_sarze, item) {
      let url;

      if (this.tankPhaseWineId !== 0)
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal?tpwId=" +
          this.tankPhaseWineId;
      else
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // console.log(response.data);
          this.sarza_items = response.data;

          let objPom = [];

          if (this.ID !== 0 && item !== null) {
            item.tankFromBatchInOperations.forEach(function (entry) {
              objPom.push(entry);
            });

            this.sarza_select = objPom;
            this.izabrani_barici = objPom;
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.sarza_items = response.data;

                      let objPom = [];

                      if (this.ID !== 0 && item !== null) {
                        item.tankFromBatchInOperations.forEach(function (
                          entry
                        ) {
                          objPom.push(entry);
                        });

                        this.sarza_select = objPom;
                        this.izabrani_barici = objPom;
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllAditiveGroup() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv_group/operation/ADDING",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.aditive_gruope_items = response.data;
          // this.aditive_gruope_items.splice(0, 0, {
          //   id: "0",
          //   name: "Izaberi grupu"
          // });
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv_group/operation/ADDING",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.aditive_gruope_items = response.data;
                      // this.aditive_gruope_items.splice(0, 0, {
                      //   id: "0",
                      //   name: "Izaberi grupu"
                      // });
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllAditiveGroup2() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv_group/operation/ADDING",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.aditive_gruope_items = response.data;
          // this.aditive_gruope_items.splice(0, 0, {
          //   id: "0",
          //   name: "Izaberi grupu"
          // });
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv_group/operation/ADDING",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.aditive_gruope_items = response.data;
                      // this.aditive_gruope_items.splice(0, 0, {
                      //   id: "0",
                      //   name: "Izaberi grupu"
                      // });
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        debugger

        if(this.additiveQuantityPom <= 0)
          alert("Ne moze se se izvrsiti dodavanje na zapreminu od 0 litara.")
        else if (this.$refs.element1.validate() && this.$refs.element2.validate()) {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && this.ID != "0") this.changeSifarnik();
            else this.newSifarnik();

            // this.isLoading = false;
          }, 1000);
        } else if (this.$refs.element1.validate()) {
          alert("Niste izabrali dodatak.");
        } else {
          alert("Niste izabrali grupu dodataka.");
        }
      }
    },
    clear() {
      this.ID = undefined;

      this.setTime();
      this.setDate();

      if (this.$refs.form !== undefined) this.$refs.form.reset();

      if (this.$refs.element1 !== undefined) this.$refs.element1.reset();

      if (this.$refs.element2 !== undefined) this.$refs.element2.reset();

      if (this.$refs.element3 !== undefined) this.$refs.element3.reset();

      if (this.ID !== 0) {
        this.ID = 0;
        this.sarza_select = [];
      }

      this.kolicinaVina = this.kolicinaVinaInit;

      if (!this.komad) {
        this.label1 = "Dodatak: ";
        this.label2 = "Grupa dodataka: ";

        this.cvalue1 = undefined;
        this.cvalue2 = undefined;
      }

      this.materialOperationId = 0;
      this.selectedArticle = 0;
      this.selectedArticleName = "";

      this.sarza_select = [];

      this.izabrani_barici = [];

      this.izabrani_aditivi = [];

      this.izabrani_aditiviPom = [];
      this.additiveQuantityPom_za_izdatnice = undefined;
      this.select_relativePom = undefined;
      this.materialOperationIdPom = undefined;
      this.selectedArticlePom = undefined;

      if (this.tank_type === "batch") this.getAllSarze(this.id_tank, null);

      this.dateFormattedOksigenacija = undefined;
      this.dateOksigenacija = undefined;
    },
    clear_init() {
      this.clear();

      this.materialFromWarehouseDocumentItemList = [];
    },
  },
  created() {
    this.tankPhaseWineId = this.$route.query.id;
  },
  mounted() {
    this.clear();

    if (this.$refs.elementsarza !== undefined) this.$refs.elementsarza.reset();

    this.getAllAditiveGroup();

    serverBus.$on("clear_adding", () => {
      this.clear_init();
    });

    serverBus.$on("applied_adding", (item) => {
      let pomNiz = [];
      pomNiz.push(item);

      this.popuni_izabrane_aditive(pomNiz);

      this.materialOperationId = item.id;

      if (item.additiv.additiveGroup.enumLabel === "oxygenation") {
        this.oksigenacija = true;

        if(item.oxygenationPerodUnitOfMeasure !== null){
          let period = this.oksigenacija_period_items.find(
          (x) => x.id === item.oxygenationPerodUnitOfMeasure.id
        );
        this.oksigenacija_period_select = period;
        }
      } else this.oksigenacija = false;

      if (item.oxygenationEndDate !== null) {
        this.dateOksigenacija = item.oxygenationEndDate.split("T")[0];

        this.timeOksigenacija = this.formatTime(
          item.oxygenationEndDate.split("T")[1]
        );
      } else {
        this.dateOksigenacija = undefined;
        this.timeOksigenacija = undefined;
      }

      if (item.macroOxygenation)
        this.oksigenacija_tip_select = {
          id: 2,
          name: "Makro",
        };
      else if (item.microOxygenation)
        this.oksigenacija_tip_select = {
          id: 1,
          name: "Mikro",
        };

      this.aditiv_gruop_select = item.additiv.additiveGroup.id;

      if (item.additiv !== null) {
        this.aditiv_select = item.additiv;
        this.label1 = "Dodatak: " + item.additiv.name;
      } else {
        this.aditiv_select = "";
        this.label1 = "Dodatak: ";
      }

      this.label2 = "Grupa dodataka: " + item.additiv.additiveGroup.name;
      this.opis = item.description;

      this.kolicinaVina = item.wineQuantityAtAddingMoment;

      this.date = item.date.split("T")[0];
      this.time = this.formatTime(item.date.split("T")[1]);

      setTimeout(() => {
        this.ID = item.id;
        if (item.quantityRelative !== null)
          this.quantityRelative = item.quantityRelative;
        else this.quantityRelative = item.quantity;

        if (item.quantityRelativeUnitOfMeasure !== null) {
          this.select_relative = item.quantityRelativeUnitOfMeasure;
          // this.getQuantity(item.quantityRelativeUnitOfMeasure);

          let pomStr = item.quantityRelativeUnitOfMeasure.mark;

          this.jm = pomStr.split("/")[0];

          if (this.jm === "g" || this.jm === "ml" || this.jm === "psc")
            this.brojDec = 1;
          else this.brojDec = 3;
        } else {
          if (item.unitOfMeasure.mark === "psc") {
            this.brojDec = 1;
            this.komad = true;
          } else this.komad = false;

          this.select_relative = item.unitOfMeasure;
        }

        this.materialFromWarehouseDocumentItemList =
          item.materialFromWarehouseDocumentItems;

        this.cvalue1 = undefined;
        this.cvalue2 = undefined;

        if (item.diffOnLastSameAdditiveGroup === true) {
          this.cvalue1 = false;
          this.cvalue2 = true;
        }

        if (item.diffOnLastSameAdditive === true) {
          this.cvalue1 = true;
          this.cvalue2 = false;
        }

        this.sarza_select = [];

        if (item.tankInBatch !== null && item.tankInBatch !== undefined)
          this.sarza_select = item.tankInBatch;

        if (this.select_relative.mark !== undefined) {
          this.jm = this.select_relative.mark.split("/")[0];

          if (this.jm === "g" || this.jm === "ml" || this.jm === "psc")
            this.brojDec = 1;
          else this.brojDec = 3;
        }

        this.additiveQuantityPom_za_izdatnice = this.additiveQuantity.toFixed(
          this.brojDec
        );
        this.select_relativePom = this.select_relative;
        this.materialOperationIdPom = this.materialOperationId;
        this.selectedArticlePom = this.selectedArticle;
        this.izabrani_aditiviPom = this.izabrani_aditivi;
      }, 500);
    });

    serverBus.$on("open_adding", (item) => {
      let pomNiz = [];
      pomNiz.push(item);

      this.popuni_izabrane_aditive(pomNiz);

      this.materialOperationId = item.id;

      if (item.additiv.additiveGroup.enumLabel === "oxygenation") {
        this.oksigenacija = true;

        let period = this.oksigenacija_period_items.find(
          (x) => x.id === item.oxygenationPerodUnitOfMeasure.id
        );
        this.oksigenacija_period_select = period;
      } else this.oksigenacija = false;

      if (item.oxygenationEndDate !== null) {
        this.dateOksigenacija = item.oxygenationEndDate.split("T")[0];

        this.timeOksigenacija = this.formatTime(
          item.oxygenationEndDate.split("T")[1]
        );
      } else {
        this.dateOksigenacija = undefined;
        this.timeOksigenacija = undefined;
      }

      if (item.macroOxygenation)
        this.oksigenacija_tip_select = {
          id: 2,
          name: "Makro",
        };
      else if (item.microOxygenation)
        this.oksigenacija_tip_select = {
          id: 1,
          name: "Mikro",
        };

      this.aditiv_gruop_select = item.additiv.additiveGroup.id;

      if (item.additiv !== null) {
        this.aditiv_select = item.additiv;
        this.label1 = "Dodatak: " + item.additiv.name;
      } else {
        this.aditiv_select = "";
        this.label1 = "Dodatak: ";
      }

      this.label2 = "Grupa dodataka: " + item.additiv.additiveGroup.name;
      this.opis = item.description;

      this.kolicinaVina = item.wineQuantityAtAddingMoment;

      this.date = item.date.split("T")[0];
      this.time = this.formatTime(item.date.split("T")[1]);

      setTimeout(() => {
        this.ID = item.id;
        if (item.quantityRelative !== null)
          this.quantityRelative = item.quantityRelative;
        else this.quantityRelative = item.quantity;

        if (item.quantityRelativeUnitOfMeasure !== null) {
          this.select_relative = item.quantityRelativeUnitOfMeasure;
          // this.getQuantity(item.quantityRelativeUnitOfMeasure);

          let pomStr = item.quantityRelativeUnitOfMeasure.mark;

          this.jm = pomStr.split("/")[0];

          if (this.jm === "g" || this.jm === "ml" || this.jm === "psc")
            this.brojDec = 1;
          else this.brojDec = 3;
        } else {
          if (item.unitOfMeasure.mark === "psc") {
            this.brojDec = 1;
            this.komad = true;
          } else this.komad = false;

          this.select_relative = item.unitOfMeasure;
        }

        this.materialFromWarehouseDocumentItemList =
          item.materialFromWarehouseDocumentItems;

        this.cvalue1 = undefined;
        this.cvalue2 = undefined;

        if (item.diffOnLastSameAdditiveGroup === true) {
          this.cvalue1 = false;
          this.cvalue2 = true;
        }

        if (item.diffOnLastSameAdditive === true) {
          this.cvalue1 = true;
          this.cvalue2 = false;
        }

        this.sarza_select = [];

        if (item.tankInBatch !== null && item.tankInBatch !== undefined)
          this.sarza_select = item.tankInBatch;

        if (this.select_relative.mark !== undefined) {
          this.jm = this.select_relative.mark.split("/")[0];

          if (this.jm === "g" || this.jm === "ml" || this.jm === "psc")
            this.brojDec = 1;
          else this.brojDec = 3;
        }

        this.additiveQuantityPom_za_izdatnice = this.additiveQuantity.toFixed(
          this.brojDec
        );
        this.select_relativePom = this.select_relative;
        this.materialOperationIdPom = this.materialOperationId;
        this.selectedArticlePom = this.selectedArticle;
        this.izabrani_aditiviPom = this.izabrani_aditivi;

        if (this.oksigenacija === true && this.dateOksigenacija === undefined)
          alert(
            "Za izbor količina sa izdanica, datum završetka oksigenacije je obavezan."
          );
        else this.dialogNote = true;
      }, 500);
    });

    serverBus.$on(
      "adding",
      (id, kolicina_vina, faza_mark, jm_mark, id_tank, tip_tanka, edit) => {
        this.tankPhaseWineId = id;
        this.kolicinaVinaInit = kolicina_vina;
        this.kolicinaVina = kolicina_vina;

        if (typeof edit !== "undefined") this.edit = edit;
        else this.edit = true;

        this.faza_mark = faza_mark;
        this.jm_mark = jm_mark;

        this.tip_tanka = tip_tanka;
        this.getAllSarze(id_tank, null);
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.addingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

#FloatingButton {
  position: absolute;
  width: 54px;
  height: 54px;
  font-size: 25px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  // transition: .2s ease-in-out;
  // p {
  //   position: relative;
  //   width: 100%;
  //   height: 100%;
  //   i {
  //     position: absolute;
  //     left: 6px;
  //     top: 6px;
  //     transform: rotate(45deg);
  //     color: #ffffff;
  //   }
  // }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

.box {
  inline-size: 90%;
  overflow-wrap: break-word;
}
</style>
